var map = {
	"./0.jpg": 818,
	"./1.jpg": 819,
	"./2.jpg": 820,
	"./3.jpg": 821,
	"./4.jpg": 822,
	"./5.jpg": 823,
	"./6.jpg": 824,
	"./7.jpg": 825,
	"./8.jpg": 826,
	"./9.jpg": 827,
	"./newPromotionBanner.jpg": 828
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 817;